import {
  ConnectionError,
  ServiceUnavailableError,
  UnauthorizedAccessError,
  NotFoundError
} from '../app/errors';
import { SlipIncorrectError, SlipConflictError, SlipUnsupportedShopError } from './errors';

const POST_HEADERS = {
  Accept: 'application/json',
  'Content-Type': 'application/json'
};

const anonymousTrackConfigUrl = `${api_config.bet_tracker_api}/anontrackconfig/`;
const associateSlipUrl = `${api_config.bet_tracker_api}/account/`;

export const getAnonymousTrackConfig = () => (
  fetch(anonymousTrackConfigUrl, {
    method: 'GET',
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;
      switch (status) {
        case 200: {
          return response;
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
    .then(response => ((response.status === 200) ? response.json() : response))
);

export const postAssociateSlip = (slipId) => (
  fetch(associateSlipUrl, {
    method: 'POST',
    headers: POST_HEADERS,
    body: JSON.stringify({ slipId }),
    credentials: 'include'
  })
    .catch(e => {
      throw new ConnectionError(e.message);
    })
    .then(response => {
      const { status, statusText } = response;

      switch (status) {
        case 204: {
          return response;
        }
        case 403: {
          throw new UnauthorizedAccessError(statusText, status);
        }
        case 400: {
          throw new SlipIncorrectError(statusText, status);
        }
        case 404: {
          throw new NotFoundError(statusText, status);
        }
        case 409: {
          throw new SlipConflictError(statusText, status);
        }
        case 418: {
          throw new SlipUnsupportedShopError(statusText, status);
        }
        case 520: {
          throw new ServiceUnavailableError(statusText, status);
        }
        default: {
          throw new ConnectionError(statusText, status);
        }
      }
    })
);
